import Campaign from './Campaign';
import { startCampaign } from '../utils/startCampaign';

const queue: Campaign<any>[] = [];

/**
 * Class to instantiate a campaign queue.
 * This will be static instantiated by each campaign types
 */
export class CampaignQueue<T> {
    public addToQueue(campaign: Campaign<T>) {
        queue.push(campaign);

        // Call processQueue only when the queue is empty
        if (queue.length === 1) {
            this.processQueue();
        }
    }

    private async processQueue() {
        // While loop which breaks only when there is no element in this.queue[]
        while (queue.length) {
            const presentCampaign: Campaign<T> = queue[0];
            if (presentCampaign) {
                startCampaign(presentCampaign);
                await presentCampaign.promise;
                // Remove the campaign from the queue after it gets resolved
                queue.shift();
            } else {
                return;
            }
        }
    }
}
